import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { createCardSorts } from '@sorare/core/src/lib/algolia';
import { CardPageSearch } from '@sorare/marketplace/src/components/market/CardPageSearch';
import { useDefaultFilters } from '@sorare/marketplace/src/hooks/useDefaultFilters';
import {
  backendClubPageFilters,
  clubPageFilters,
} from '@sorare/marketplace/src/searchCards/nba/cardFilters';

import type { NBATeamSearch_team } from './__generated__/index.graphql.ts';

type Props = {
  team: NBATeamSearch_team;
};

const cardSorts = createCardSorts({ withHighestAverageScore: true });

export const Search = ({ team }: Props) => {
  const filters = useDefaultFilters({
    teamSlug: team.slug,
  });

  return (
    <FullWidthContainer>
      <CardPageSearch
        sport={Sport.NBA}
        sorts={cardSorts}
        defaultSort="Newly Listed"
        analyticsTags={['Team', 'NBA']}
        defaultFilters={filters}
        cardFilters={clubPageFilters}
        backendCardFilters={backendClubPageFilters}
        topic={{ type: 'team', label: team.name }}
      />
    </FullWidthContainer>
  );
};

Search.fragments = {
  team: gql`
    fragment NBATeamSearch_team on TeamInterface {
      slug
      name
    }
  ` as TypedDocumentNode<NBATeamSearch_team>,
};
